import React, { useEffect } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import { useRoute } from '@react-navigation/native';
import { useAppSelector } from 'ReduxStore/hooks';
import { GetAppRouteConfigMap } from './getAppRouteConfigMap';
import { IconMenu, iconSearch } from './navigationHeaderIcons';
import { navigationStyles } from './navigationOptions';
import { TOP_BAR_TOTAL_HEIGHT, MINIMISED_OFFSET } from './Menu/Menu.styles';

const WEB_WIDTH = 1280;
const PADDING = 32;
const NAV_ICON_WIDTH = 50;
const titleHeaderWidth = WEB_WIDTH - PADDING * 2 - NAV_ICON_WIDTH * 2;

const CreateRootStack = ({ userData, Nav }) => {
    const routeConfigMap = { ...GetAppRouteConfigMap() };
    const routeConfigArray = [];
    const isMinimised = useAppSelector((state) => state.webMenu.isMinimised);

    Object.keys(routeConfigMap).forEach((key) => {
        // if (options.page) {
        //     routeConfigMap[options.route] = {
        //         screen: options.page,
        //         navigationOptions: {
        //             headerTitle: options.title.toUpperCase(),
        //             headerLeft: () => iconMenu,
        //             headerRight: () => iconSearch
        //         }
        //     };
        // }

        // if (options.rootStack) {
        //     routeConfigMap[options.route] = options.rootStack;
        // }
        if (routeConfigMap[key].requiresLogin && !userData) {
            return;
        }
        routeConfigArray.push(
            <Nav.Screen
                name={`${key}`}
                key={`${key}stack`}
                component={routeConfigMap[key].screen}
                options={routeConfigMap[key].navigationOptions} // TODO hide state  of header if commented
                initialParams={routeConfigMap[key].params}
            />
        );
    });
    const screenOptions = {
        presentation: 'card',
        animation: 'fade',

        gestureEnabled: false,
        animationEnabled: !Device.isWeb,
        headerLeft: IconMenu,
        headerStyle: navigationStyles.headerStyle,
        headerTintColor: Theme.primaryTextColor,
        headerTitleStyle: navigationStyles.headerTitleStyle,
        cardStyle: { backgroundColor: Theme.primaryBackgroundColor },
        headerTitleContainerStyle: {
            width: '100%',
            flex: 10
        },
        headerLeftContainerStyle: { flex: 1 },
        headerRightContainerStyle: { flex: 1 },
        cardStyle: { flex: 1, overflow: 'auto' },
        ...(Device.isWeb
            ? {
                  headerTransparent: true,
                  headerBackgroundContainerStyle: navigationStyles.headerStyle,
                  headerStatusBarHeight: isMinimised
                      ? TOP_BAR_TOTAL_HEIGHT - MINIMISED_OFFSET
                      : TOP_BAR_TOTAL_HEIGHT,
                  transition: 'margin .16s linear',
                  headerTitleContainerStyle: {
                      width: titleHeaderWidth,
                      justifyContent: 'center',
                      left: '50%',
                      marginLeft: -NAV_ICON_WIDTH / 4,
                      alignSelf: 'center'
                  },
                  headerLeftContainerStyle: {
                      width: NAV_ICON_WIDTH,
                      left: '50%',
                      marginLeft: -(titleHeaderWidth / 2) - NAV_ICON_WIDTH,
                      zIndex: 999
                  },
                  headerRightContainerStyle: {
                      width: NAV_ICON_WIDTH,
                      // left: '50%',
                      marginLeft: titleHeaderWidth / 2
                  }
              }
            : {})
    };
    return { routeConfigArray, screenOptions };
    // <Stack.Navigator
    //     backBehavior="history"
    //     // initialRouteName={options.route}
    //     screenOptions={{
    //         presentation: 'modal',
    //         animationEnabled: !Device.isWeb,
    //         headerLeft: () => iconMenu,
    //         headerStyle: navigationStyles.headerStyle,
    //         headerTintColor: Theme.primaryTextColor,
    //         headerTitleStyle: navigationStyles.headerTitleStyle,
    //         cardStyle: { backgroundColor: Theme.primaryBackgroundColor },
    //         headerTitleContainerStyle: {
    //             width: '100%',
    //             flex: 10
    //         },
    //         headerLeftContainerStyle: { flex: 1 },
    //         headerRightContainerStyle: { flex: 1 },
    //         ...(Device.isWeb
    //             ? {
    //                   headerTransparent: true,
    //                   headerBackgroundContainerStyle: navigationStyles.headerStyle,
    //                   headerStatusBarHeight: isMinimised
    //                       ? TOP_BAR_TOTAL_HEIGHT - MINIMISED_OFFSET
    //                       : TOP_BAR_TOTAL_HEIGHT,
    //                   transition: 'margin .16s linear',
    //                   headerTitleContainerStyle: {
    //                       width: titleHeaderWidth,
    //                       justifyContent: 'center',
    //                       left: '50%',
    //                       marginLeft: -NAV_ICON_WIDTH / 4,
    //                       alignSelf: 'center'
    //                   },
    //                   headerLeftContainerStyle: {
    //                       width: NAV_ICON_WIDTH,
    //                       left: '50%',
    //                       marginLeft: -(titleHeaderWidth / 2) - NAV_ICON_WIDTH,
    //                       zIndex: 999
    //                   },
    //                   headerRightContainerStyle: {
    //                       width: NAV_ICON_WIDTH,
    //                       // left: '50%',
    //                       marginLeft: titleHeaderWidth / 2
    //                   }
    //               }
    //             : {})
    //     }}
    // >
    //     {routeConfigArray}
    // </Stack.Navigator>
};

export default CreateRootStack;
